// extracted by mini-css-extract-plugin
var _1 = "ApplicantReadMoreText-moduleApplicantReadMoreText__eSHSD";
var _2 = "ApplicantReadMoreText-moduletext__chamf";
export { _1 as "ApplicantReadMoreText", _2 as "text" }
